export const comments_5588476 = {"data":{"data":[],"links":{}}}